export const state = {
  socialEntities: []
}
